import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Tooltip_Finding_Base } from './Tooltip_Finding_Base.js';
import { _className, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Tooltip_Finding_Enum.scss';
export class Tooltip_Finding_Enum extends Tooltip_Finding_Base {
    //######################### Render #########################
    render_Content = () => {
        return _jsxs(_Fragment, { children: [this.render_Source(), this.render_Divider(), _jsx(LL_V_L, { className: 'finding-tooltip__content enum', children: this.render_Results() })] });
    };
    //######################### Render - Results #########################
    render_Results = () => {
        return _jsxs(LL_V_L, { className: 'enum-results', children: [_jsx("div", { className: 'enum-results__section-title', children: "Results:" }), this.state.data.results.map(this.render_Result)] });
    };
    render_Result = (result, index) => {
        const timestamp = this.resolveTimestamp(result);
        const value = this.resolveValue(result);
        const className = _className('enum-result', !result.currentEncounter && 'prev-encounter');
        return _jsxs(LL_V_L, { className: className, children: [_jsxs(LL_H_C, { className: 'enum-result__title', children: [_jsx("div", { className: 'enum-result__value', children: value }), _jsx("div", { className: 'enum-result__timestamp', children: timestamp })] }), this.render_Attributes(result)] }, index);
    };
    //######################### Render - Attributes #########################
    render_Attributes = (result) => {
        if (!result.attributes?.length)
            return;
        return _jsx(LL_V_L, { className: 'enum-attributes', children: result.attributes.map((attResult, index) => {
                const last = index === result.attributes.length - 1;
                const key = `${attResult.variable._id}-${attResult.results[0].valueId}`;
                return _jsxs(React.Fragment, { children: [this.render_Attribute(attResult), !last && this.render_Divider()] }, key);
            }) });
    };
    render_Attribute = (attData) => {
        const value = this.resolveValue(attData.results[0]);
        return _jsxs(LL_H_C, { className: 'enum-attribute', children: [_jsx("div", { className: 'enum-attribute__name', children: this.resolveVariableName(attData.variable) }), _jsx("div", { className: 'enum-attribute__value', children: value })] });
    };
}
//# sourceMappingURL=Tooltip_Finding_Enum.js.map